import { render } from "./LbrxSlider.vue?vue&type=template&id=ef392624"
import script from "./LbrxSlider.vue?vue&type=script&lang=js"
export * from "./LbrxSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__